import { PostEnquiryReducersType } from "./post-enquiry.type";

export const DEFAULT_VALUE_POST_ENQUIRY_STORAGE = {
    excludedIds: [],
    lastShowTime: null,
    shouldDisplay: true
};

export const DEFAULT_VALUE_POST_ENQUIRY: PostEnquiryReducersType= {
    showMortgageCallbackDialog: false,
    showNextTimePostEnquiryDialog: false,
    showPostEnquiryDialog: false,
    showSuccessPostEnquiryDialog: false,
    storage: DEFAULT_VALUE_POST_ENQUIRY_STORAGE
};

export const POST_ENQUIRY_DELAY_SHOW = 5000;

export const POST_ENQUIRY_NEXT_SHOW_HOUR = 24;

export const DEFAULT_KEY_POST_ENQUIRY_STORAGE = 'enquiry-popup';

export const DUMMY_POST_ENQUIRY = [
    {
        address: 'Lebak Bulus, Jakarta Selatan',
        attribute: {
            bathroom: '1',
            bedroom: '2',
            buildingSize: 'Luas Bangunan : 60m²',
            buildingSizeShort: 'LB : 60m²',
            carport: '1',
            landSize: 'Luas Tanah : 60m²',
            landSizeShort: 'LT : 60m²'
        },
        checkboxValue: [1],
        id: '22u1983121',
        isChecked: true,
        media: [
            {
                alt: '',
                id: 'image-1',
                src:
                    'https://picture.rumah123.com/r123/750x420-crop/house/ho82/8230323/original/hos8230323-rumah-di-jual-di-setu-tangerang-selatan-1619496832077.jpg'
            },
            {
                alt: '',
                id: 'image-2',
                src:
                    'https://picture.rumah123.com/r123/750x420-crop/house/ho82/8230323/original/hos8230323-rumah-di-jual-di-setu-tangerang-selatan-16194971360414.jpg'
            }
        ],
        onChangeCheckbox: (): void => undefined,
        priceTag: 'Rp 2,1 M',
        propertyType: 'Rumah',
        title: 'Rumah Murah Siap Huni di Lebak Bulus'
    },
    {
        address: 'Lebak Bulus, Jakarta Selatan',
        attribute: {
            buildingSize: 'Luas Bangunan : 60m²',
            buildingSizeShort: 'LB : 60m²',
            landSize: 'Luas Tanah : 60m²',
            landSizeShort: 'LT : 60m²'
        },
        checkboxValue: [1],
        id: '22u1983112',
        isChecked: true,
        media: [
            {
                alt: '',
                id: 'image-1',
                src:
                    'https://picture.rumah123.com/r123/750x420-crop/house/ho82/8230323/original/hos8230323-rumah-di-jual-di-setu-tangerang-selatan-1619496832077.jpg'
            },
            {
                alt: '',
                id: 'image-2',
                src:
                    'https://picture.rumah123.com/r123/750x420-crop/house/ho82/8230323/original/hos8230323-rumah-di-jual-di-setu-tangerang-selatan-16194971360414.jpg'
            },
            {
                alt: '',
                id: 'image-3',
                src:
                    'https://picture.rumah123.com/r123/750x420-crop/house/ho82/8230323/original/hos8230323-rumah-di-jual-di-setu-tangerang-selatan-1619496832077.jpg'
            }
        ],
        onChangeCheckbox: (): void => undefined,
        priceTag: 'Rp 450JtM',
        propertyType: 'Rumah',
        title: 'Rumah Murah Siap Huni di Lebak Bulus'
    },
    {
        address: 'Lebak Bulus, Jakarta Selatan',
        attribute: {
            bathroom: '1',
            bedroom: '2',
            buildingSize: 'Luas Bangunan : 60m²',
            buildingSizeShort: 'LB : 60m²',
            carport: '1',
            landSize: 'Luas Tanah : 60m²',
            landSizeShort: 'LT : 60m²'
        },
        checkboxValue: [1],
        id: '22u1980123',
        isChecked: true,
        media: [
            {
                alt: '',
                id: 'image-1',
                src:
                    'https://picture.rumah123.com/r123/750x420-crop/house/ho82/8230323/original/hos8230323-rumah-di-jual-di-setu-tangerang-selatan-1619496832077.jpg'
            },
            {
                alt: '',
                id: 'image-2',
                src:
                    'https://picture.rumah123.com/r123/750x420-crop/house/ho82/8230323/original/hos8230323-rumah-di-jual-di-setu-tangerang-selatan-16194971360414.jpg'
            },
            {
                alt: '',
                id: 'image-3',
                src:
                    'https://picture.rumah123.com/r123/750x420-crop/house/ho82/8230323/original/hos8230323-rumah-di-jual-di-setu-tangerang-selatan-1619496832077.jpg'
            }
        ],
        onChangeCheckbox: (): void => undefined,
        priceTag: 'Rp 450JtM',
        propertyType: 'Rumah',
        title: 'Rumah Murah Siap Huni di Lebak Bulus'
    }
];
